'use strict';
var Helper = require('./helper');
var PassengersCollection = require('../collections/passengers.collection');
var SeatMapPreferencesSelection = require('../collections/seatmap_preferences_selections.collection');
var PriceManagerPublisher = require('../mixins/price_publisher.mixin');
const seatMapUtils = require('./seatmap.utils');
const SeatsTracking = require('../../tracking/bags_and_seats/seats_tracking').getInstance();

const PRIME_DISCOUNT_AMOUNT_THRESHOLD = 10;

module.exports = new Helper(PriceManagerPublisher.extend({
    modelClass: require('../models/seatmap_selection.model'),
    viewClass: null,
    exposedMethods: null,
    seatMapSelectionCollection: SeatMapPreferencesSelection.getInstance(),
    passengerCollection: PassengersCollection.getInstance(),
    descriptorsScheme: {},
    analitycLabel: '',
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
        if (this.options.isPostBooking || this.options.hasToShow) {
            this.initCollections();
        }
        if (!this.options.isPostBooking) {
            this.triggerNagSubscribeEvent();
        }
        if ( !this.options.hasToShow && !this.options.isCheckin) {
            SeatsTracking.trackSeatsOnLoadError('notavail');
        }
    },
    initCollections: function() {
        this.constructCollections();
        this.removeStoragedSeatPreferenceSelection();
    },
    getProviderTracking: function() {
        return this.options.fareItineraryProvider || 'other';
    },
    constructCollections: function() {
        if (!this.options.isPostBooking) {
            this.model.fetch(this.model.getDataRequestSettings());
        }
        this.setupViewOptions();
        this.afterConstructCollections();
    },
    afterConstructCollections: function() {
        if (!this.options.isPostBooking) {
            this.passengerCollection.setUp(this.options);
        }
        this.seatMapSelectionCollection.setUp(this.options);
        this.bindEvents();
    },
    removeStoragedSeatPreferenceSelection: function() {
        Odigeo.Session.remove('seatPreferenceSelection');
    },
    setupViewOptions: function() {
        this.analitycLabel = this.options.analitycLabel;
    },
    bindEvents: function() {
        this.listenTo(this.model, 'responseIsOK', Odigeo._.bind(this.toggleLoadingSeats, this, false));
        this.listenTo(this.model, 'responseIsKO', Odigeo._.bind(this.toggleLoadingSeats, this, true));
        this.listenTo(this.model, 'responseIsOK', this.updateDescriptors, this);
        this.listenTo(this.model, 'responseIsKO', this.view.hideSeatSelection, this);
        this.listenTo(this.passengerCollection, 'passengerCollectionIsOk', this.sendResponsePassengerCollectionIsOk, this);
        this.listenTo(this.seatMapSelectionCollection, 'seatMapSelectionResponseIsOK', this.updateViewWithSelections, this);
        this.listenTo(this.seatMapSelectionCollection, 'add', this.updateView, this);
        this.listenTo(this.seatMapSelectionCollection, 'remove', this.updateView, this);
        this.listenTo(this.seatMapSelectionCollection, 'reset', this.updateView, this);
    },
    triggerNagSubscribeEvent: function() {
        const seatsInfo = {
            widgetId: 'seatmap-selection',
            details: {
                isEnabled: false,
                priceData: {},
                seatsContinueNagAlreadyShown: false,
                seatsRemoveNagAlreadyShown: false,
            },
        };
        Odigeo.trigger(`${this.id}:nagSubscribe`, seatsInfo);
    },
    updateSeatFees: function($seatFeeTextContainer, $seatFeeHintButton, seatFeeDisclaimer) {
        const seatSelectionFees = this.seatMapSelectionCollection.getSeatSelectionFees();
        const shouldHideFeeDisclaimer = this.seatMapSelectionCollection.length === 0 || seatSelectionFees <= 0;

        if (!shouldHideFeeDisclaimer) {
            $seatFeeTextContainer.html(Odigeo.Utils.replaceCmsKeyArgs(
                seatFeeDisclaimer,
                Odigeo.Utils.formatCurrency(seatSelectionFees)
            ));
        }

        $seatFeeTextContainer.toggleClass('odf-hidden', shouldHideFeeDisclaimer);
        $seatFeeHintButton.toggleClass('odf-hidden', shouldHideFeeDisclaimer);
    },
    updateDescriptors: function(descriptors) {
        this.setDescriptorsScheme(descriptors);
        const isOnlineSeatMap = !this.options.isPostBooking && !this.options.isCheckin;
        this.model.set('primeInfo', isOnlineSeatMap ?
            this.setupPrimeInfo()
            : {
                isPrimeView: false,
            });
        this.view.initPrimeView();
        SeatsTracking.setPrimeInfo(this.model.get('primeInfo'));
        this.model.set('pristineMoveThrough', true);
        this.setPreferredSeatsThresholds(descriptors);
        this.view.activeButton();
        Odigeo.trigger(`${this.id}:notifyNagProductEnabled`, 'seatmap-selection', this.hasSeatsAvailable());
        this.view.autoOpenAircraft();
    },
    setDescriptorsScheme: function(descriptors) {
        this.descriptorsScheme = descriptors;
    },
    setupPrimeInfo: function() {
        const isSeatsPrimeDiscounts = Odigeo.AB.isSeatsPrimeDiscountsDesktop;

        const {mostDiscountedSectionSeats, maxDiscountPercentage} = this.getMostDiscountedSeatsInfo();

        const maxDiscountAmount = seatMapUtils.getMaxTotalPrimeDiscount(mostDiscountedSectionSeats, this.options.nEligibleTravellers);

        const isPrimeProductOffered = Odigeo.Membership.isMembershipProductEnabled;
        const isUserPrimeMemberAndNotLogged = Odigeo.Membership.isUserPrimeMemberAndNotLogged;
        const isPriceWithDiscountSelected = Odigeo.Membership.isPriceWithoutDiscountSelected === 'false';
        const hasAValidDiscount = maxDiscountPercentage > 0;

        const memberName = Odigeo.Membership.membershipUserName;
        const isPrimeUser = memberName ? memberName.length > 0 : false;
        const isPrimeFareOffered = (isUserPrimeMemberAndNotLogged || isPrimeProductOffered) && isPriceWithDiscountSelected;

        const isDiscountDisplayPercentage = maxDiscountPercentage >= PRIME_DISCOUNT_AMOUNT_THRESHOLD || maxDiscountPercentage >= maxDiscountAmount;
        const discountDisplayType = isDiscountDisplayPercentage ? 'per' : 'abs';
        const merchandisingBadgeDiscountText = isDiscountDisplayPercentage
            ? `-${maxDiscountPercentage}%`
            : Odigeo.Utils.formatCurrency(maxDiscountAmount, {...Odigeo.Utils.Currency, decimalPlaces: 0});

        const isPrimeView = isSeatsPrimeDiscounts && (isPrimeFareOffered || isPrimeUser) && hasAValidDiscount;

        return {
            isPrimeView,
            isPrimeUser,
            maxDiscountPercentage,
            maxDiscountAmount,
            merchandisingBadgeDiscountText,
            discountDisplayType,
            mostDiscountedSectionSeats,
        };
    },
    getMostDiscountedSeatsInfo: function() {
        const seatMapPreferencesDescriptors = this.descriptorsScheme;
        const mostDiscountedSectionSeats = [];
        let maxDiscountPercentage = 0;

        Object.values(seatMapPreferencesDescriptors.attributes).forEach((seatMapPreferencesDescriptor) => {
            seatMapPreferencesDescriptor.seatMap?.forEach((seatMap) => {
                let sectionSeats = [];

                seatMap.cabin.forEach((cabin) => {
                    if (cabin.seats !== undefined && !Odigeo._.isEmpty(cabin.seats.seat)) {
                        sectionSeats.push(cabin.seats.seat);
                    }
                });

                sectionSeats = sectionSeats.flat();
                const {mostDiscountedPrimeSeat, highestPrimeDiscountPercentage, minSectionPrimePrices} = seatMapUtils.getPrimeDiscountsInfo(
                    sectionSeats
                );
                seatMap.minSectionPrimePrices = minSectionPrimePrices;
                if (mostDiscountedPrimeSeat !== undefined) {
                    mostDiscountedSectionSeats.push(mostDiscountedPrimeSeat);
                } else {
                    mostDiscountedSectionSeats.push({});
                }
                if (highestPrimeDiscountPercentage > maxDiscountPercentage) {
                    maxDiscountPercentage = highestPrimeDiscountPercentage;
                }
            });
        });

        return {
            mostDiscountedSectionSeats,
            maxDiscountPercentage,
        };
    },
    hasSeatsAvailable: function() {
        const segments = Odigeo._.get(this.descriptorsScheme, 'attributes', {});
        for (let segment in segments) {
            if (Odigeo._.get(segments[segment], 'seatMap', []).length > 0) {
                return true;
            }
        }

        return false;
    },
    setPreferredSeatsThresholds: function(descriptors) {
        this.model.set('preferredSeatsThreshold', seatMapUtils.generatePreferredSeatsThresholds(descriptors));
    },
    getSeatMap: function(segment, section) {
        var seatMapDescriptors = {};
        Odigeo._.each(this.descriptorsScheme.attributes, function(seatMapDescriptor) {
            if (seatMapDescriptor.segment === segment) {
                Odigeo._.each(seatMapDescriptor.seatMap, function(seatmap) {
                    if (seatmap.section === section) {
                        seatMapDescriptors = seatmap;
                    }
                }, this);
            }
        }, this);
        return seatMapDescriptors;
    },
    hasSeatsAndEnoughForAllPassengers: function(descriptor) {
        var hasSeats = !Odigeo._.isEmpty(descriptor.seats) && !Odigeo._.isEmpty(descriptor.seats.seat);
        var seats = !hasSeats ? 0 : Odigeo._.size(descriptor.seats.seat);
        var noSeats = !hasSeats ? 0 : Odigeo._.size(Odigeo._.filter(descriptor.seats.seat, {type: 'NO_SEAT'}));
        return {
            hasSeats: !hasSeats ? false : seats - noSeats > 0,
            hasSeatsForAllPax: !hasSeats ? false : seats - noSeats > this.options.nTravellers,
        };
    },
    getSeatMapSegments: function() {
        return Odigeo._.filter(this.descriptorsScheme.attributes, function(segment) {
            return Odigeo._.isObject(segment) && segment.segment >= 0;
        });
    },
    getNumberOfSectionsWithSelectableSeats: function() {
        return Odigeo._.reduce(this.getSeatMapSegments(), function(sectionCount, segment) {
            return Odigeo._.size(segment.seatMap) + sectionCount;
        }, 0);
    },
    getFirstSectionWithAvailableSeats: function(seatMapSegments) {
        return Odigeo._.get(Odigeo._.find(seatMapSegments, function(segment) {
            return Odigeo._.size(segment.seatMap) > 0;
        }), 'seatMap[0].section', 0);
    },
    updateView: function() {
        if (this.options.isPostBooking || this.options.hasToShow) {
            this.view.updateView();
        }
    },
    toggleLoadingSeats: function(hasError) {
        if (hasError) {
            SeatsTracking.trackSeatsOnLoadError('NA');
        }
        this.view.hideLoadingSeatMap();
    },
    updateSelectedSeats: function() {
        var seatsSelected = !Odigeo._.isEmpty(this.seatMapSelectionCollection) ? this.createSeatMapSelectionCollection() : {};
        Odigeo.trigger(this.id + ':updateSeatsInPassengersPage', seatsSelected);
    },
    createSeatMapSelectionCollection: function() {
        var seatsSelected = {
            seatData: {
                seatMapSelectionRequests: [],
                numberOfRetries: this.retries,
            },
        };

        this.seatMapSelectionCollection.each(function(model) {
            seatsSelected.seatData.seatMapSelectionRequests.push({
                sections: [model.get('section')],
                numPassenger: model.get('numPassenger'),
                floor: model.get('floorSelection'),
                row: model.get('rowSelection'),
                seatMapRow: model.get('seatMapRow'),
                column: model.get('columnSelection'),
                selection: true,
            });
        }, this);
        return seatsSelected;
    },
    updateTotalPriceValues: function(bookingId) {
        let total = 0;
        let totalPrime = 0;
        let quantity = 0;
        let decimalplaces;

        this.seatMapSelectionCollection.each(function(seat) {
            total += seat.get('totalPrice');
            totalPrime += seat.get('totalPrimePrice');
            quantity++;
        }, this);
        decimalplaces = total ? 2 : 0;
        this.view.updatePriceView(total, totalPrime, decimalplaces);

        this.addItemToPricemanagerCollection({
            allPrice: total,
            allPrimePrice: totalPrime,
            conceptKey: 'seatmap',
            onePrice: total / quantity,
            quantity: quantity,
        });

        this.updatePriceBreakDown({
            allprice: total,
            allprimeprice: totalPrime,
            concept: 'seatmap',
            oneprice: total / quantity,
            quantity: quantity,
        });

        const data = JSON.stringify(this.seatMapSelectionCollection.toJSON());
        Odigeo.Session.set('seatPreferenceSelection', data);
        Odigeo.Session.set('seatSelection_' + bookingId, data);
    },
    updatePassengers: function() {
        this.passengerCollection.updatePassengers();
    },
    showErrors: function() {
        this.hideErrors();
        this.view.showErrors();
    },
    hideErrors: function() {
        this.view.hideErrors();
        this.view.hideRetryWarnings();
    },
    updatePriceBreakDown: function(totalPriceData) {
        var request = {
            seatData: {},
            priceData: {
                data: totalPriceData,
                id: 'seatmap',
                type: 'seatmap',
            },
        };
        if (!Odigeo._.isEmpty(this.seatMapSelectionCollection)) {
            request.seatData = {
                seatMapSelectionRequests: [],
                numberOfRetries: this.retries,
            };
            this.seatMapSelectionCollection.each(function(model) {
                request.seatData.seatMapSelectionRequests.push({
                    sections: [model.get('section')],
                    numPassenger: model.get('numPassenger'),
                    floor: model.get('floorSelection'),
                    row: model.get('rowSelection'),
                    seatMapRow: model.get('seatMapRow'),
                    column: model.get('columnSelection'),
                    selection: true,
                });
            }, this);
        }
        Odigeo.trigger(this.id + ':seatMapSelected', request);
    },
    seatMapSelectionRetryError: function(errors) {
        this.analyticsEventTracking({label: 'seat_selection_gds_submit_error'});
        this.hideErrors();
        this.retries = this.retries + 1;
        if (this.retries > this.options.maxRetries) {
            Odigeo.trigger(this.id + ':severalRetries');
        } else {
            this.view[this.retries === this.options.maxRetries ? 'showNoMoreRetries' : 'showErrors']();
            this.manageRetryErrors(errors);
            this.model.fetch();
        }
    },
    manageRetryErrors: function(errors) {
        Odigeo._.each(errors, function(error) {
            if (error.code === 'SEATMAP_SELECTION_RETRY_NOT_AVAILABE_ERROR_CODE') {
                this.manageSeatNotAvaliableErrors(error.seatMapFlightDetails);
            } else if (error.code === 'SEATMAP_SELECTION_RETRY_NUMPAX_ERROR_CODE') {
                this.manageNumMaxErrors(error.seatMapFlightDetails);
            }
        }, this);
    },
    manageSeatNotAvaliableErrors: function(seatNotAvaliableErrors) {
        Odigeo._.each(seatNotAvaliableErrors, function(sectionWithError) {
            this.seatMapSelectionCollection.removeSelection(this.seatMapSelectionCollection
                .getFlightSeats(sectionWithError.section));
            this.view.showRetryWarning(sectionWithError.segment, sectionWithError.section);
        }, this);
    },
    initializeSeatView: function(response) {
        var isLoaded = false;
        var availability = false;
        Odigeo._.each(response, Odigeo._.bind(function(seatMap) {
            var seatMapSection = seatMap.seatMap;
            var $segment = this.$el.find('.hide_seats[data-segment="' + seatMap.segment + '"]');
            if (Odigeo._.isEmpty(seatMapSection)) {
                $segment.removeClass('seatmapselection_flight_section');
                $segment.find('.add_seats').addClass('odf-hidden');
                $segment.find('.not_seats').removeClass('odf-hidden');
                $segment.find('.seats_arrow').addClass('odf-hidden');
            } else {
                $segment.addClass('seatmapselection_flight_section');
                $segment.find('.not_seats').addClass('odf-hidden');
                $segment.find('.add_seats').removeClass('odf-hidden');
            }
            isLoaded = isLoaded || (Odigeo._.isObject(seatMap) && seatMap.status === 'LOADED');
            availability = !Odigeo._.isEmpty(seatMapSection) || availability;
        }, this));
        if (!availability) {
            SeatsTracking.trackSeatsOnLoadError('notavail');
        }
        return isLoaded;
    },
    getTrackingConfig: function() {
        return {
            type: 'trackEvent',
            data: {
                category: this.options.isPostBooking ? 'my_area_trips_details' : 'flights_pax_page',
                action: 'seat_selection',
            },
        };
    },
    analyticsEventTracking: function(label) {
        var clonedDataTracking = $.extend(true, {}, this.getTrackingConfig());
        Odigeo._.extend(clonedDataTracking.data, label);
        if (!this.options.isCheckin) {
            Odigeo.trigger('analytics:tracking', clonedDataTracking);
        }
        return this;
    },
    execute: function(func) {
        return Odigeo.Utils.executeInternalMethods(this, this.exposedMethods, func, Odigeo._.toArray(arguments).slice(1));
    },
}));
